import "./referentiel_lists.css";
import react, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';

import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import Add_infos_modal from "./add_infos_modal";
import { get_values_lists, update_value_from_list } from "../../../services/company_admin_service";


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

const columns = [
    { id: 'label', label: "Libellé", minWidth: 0 },
    { id: 'code', label: "Code", minWidth: 0 },
    { id: 'archived', label: "Statut", minWidth: 0 }
];


function state(archived) {
    return (
        <>
            {
                archived === 1
                    ? <Button variant="contained" className="status_deny">{"archivée"}</Button>
                    : <Button variant="contained" className="status_success">{"non archivée"}</Button>
            }
        </>
    );
}



function List_Values({ list, archive, setupdate_infos, setadd_infos_modal, users, all_directions }) {

    return (
        <>
            {
                list.map((data, id) => (
                    <TableRow key={"direction" + id}>
                        <TableCell align="left">
                            <div style={{ width: 'fit-content' }}>
                                {data.label}
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Tooltip title="modifier" placement="top" >
                                        <span className={"editIcon"} onClick={() => { setupdate_infos(data); setadd_infos_modal(true) }} >
                                            <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="left">  {data.code} </TableCell>
                        <TableCell align="center">
                            <div className='documentsStatus_valide'  >
                                <div>
                                    <div><CheckIcon className="checkIcon" onClick={() => archive(id, data, 0)} /></div>
                                    <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive(id, data, 1)} /></div>
                                </div>
                                {state(data.archived)}
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}


const Referentiel_lists_container = () => {
    const classes = useStyles();
    const [url_updated, setUrl_updated] = useState(null);
    let history = useHistory();

    const [data, setData] = useState(null);
    const [infos_type, setInfos_type] = useState("financial_terms");
    const [add_infos_modal, setadd_infos_modal] = useState(false);
    const [update_infos, setupdate_infos] = useState(null);

    const [infos_updated, set_infos_updated] = useState(null);

    const [waiting, setWaiting] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(6);
    const [data_count, setdata_count] = useState(0);

    useEffect(() => {
        setData(null);
        setdata_count(0);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let infos_type_tmp = infos_type;

        async function load_data() {
            if (urlParams.get('info')) {
                setInfos_type(urlParams.get('info'));
                infos_type_tmp = urlParams.get('info');
            }
            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page);
            await get_values_lists(page).then((response) => {
                setData(response.data);
            }).catch((error) => {
                console.log(error.response);
                setData({})
            });
        }

        load_data();
    }, [infos_updated, url_updated, history.location]);

    function archive(id, infos, value) {
        console.log(infos);
        setWaiting(true);
        let formData = new FormData();
        formData.append('id',infos.id);
        formData.append('code',infos.code);
        formData.append('label',infos.label);
        formData.append("type",infos_type);
        formData.append('archived', value);
        update_value_from_list(formData).then((response) => {
            console.log(response);
            let tmp_arr = {...data};
            tmp_arr[infos_type][id].archived = value;
            setData(tmp_arr);
            setWaiting(false);
        }).catch((error) => {
            console.log(error.response);
            setWaiting(false);
        })
    }

    function set_infos_types_page(value) {
        let path = history.location.pathname;
        history.push(path + "?info=" + value);
        setUrl_updated(value);
    }

    async function change_page(page) {
        await setCurrentPage(page);
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;
        if (!params) history.push(path + "?page=" + page);
        else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    if (i == 0) tmp_params = tmp_params + "?page=" + page;
                    else tmp_params = tmp_params + "&page=" + page;
                } else {
                    if (i == 0) tmp_params = tmp_params + search_params[i];
                    else tmp_params = tmp_params + "&" + search_params[i];
                }
            }
            if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
            history.push(tmp_params);
        }
        await setUrl_updated(page);
    }

    return (
        <>
            {
                data == null
                    ? <Loading_animation_view />
                    : <div className='categories_list_container'>
                        <div className='categories_list_container_header'>
                            <div className='title_container'>
                                <FormControl variant="standard" className="header_form">
                                    <Select required value={infos_type}
                                        onChange={e => { set_infos_types_page(e.target.value) }} >
                                        <MenuItem value={"financial_terms"} >Conditions financières</MenuItem>
                                        <MenuItem value={"payment_terms"} >Conditions de paiement</MenuItem>
                                        <MenuItem value={"billing_terms"} >Conditions de facturation</MenuItem>
                                    </Select>
                                </FormControl>

                                <Button variant="contained" startIcon={<AddIcon className="my_icon" />} className={waiting ? "submit_but disabled_button" : "submit_but"} onClick={() => setadd_infos_modal(true)}>
                                    Ajouter
                                </Button>
                            </div>
                            <div className='select_container'>
                                {/* <FormControl variant='standard' className={classes.formControl} style={{width:"225px"}} >
                                <InputLabel>Etat de famille</InputLabel>
                                    <Select required
                                        value={categorie_state}
                                        onChange={e => {
                                            select_categorie_stat(e.target.value);
                                        }} name="Etat" >
                                        <MenuItem value={"default"} disabled>
                                            Etat de famille
                                        </MenuItem>
                                        <MenuItem value={"recent"}>Récent</MenuItem>
                                        <MenuItem value={"old"}>Ancien</MenuItem>
                                    </Select>
                            </FormControl> */}
                            </div>
                        </div>
                        <TableContainer className="categories_list_table" style={{ minWidth: "800px" }}>
                            <Table className={classes.table} aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => (
                                                <TableCell key={column.id} align="left">{column.label}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.hasOwnProperty(infos_type)
                                            ?
                                            <>
                                                <List_Values list={data[infos_type]} archive={archive} setadd_infos_modal={setadd_infos_modal}
                                                    setupdate_infos={setupdate_infos} />

                                            </>
                                            : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun infos</div>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {
                            data.length !== 0
                                ? <div className="pagination_container">
                                    <Pagination
                                        activePage={Number(currentPage)}
                                        itemsCountPerPage={dataPerPage}
                                        totalItemsCount={Number(data_count)}
                                        pageRangeDisplayed={4}
                                        onChange={change_page.bind(this)}
                                    />
                                </div>
                                : <></>
                        }
                    </div>
            }

            {
                add_infos_modal !== false
                    ? <Add_infos_modal add_infos_modal={add_infos_modal} setadd_infos_modal={setadd_infos_modal} setupdate_infos={setupdate_infos}
                        infos_type={infos_type} update_infos={update_infos} data={data} setData={setData} />
                    : <></>
            }

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default Referentiel_lists_container;